export const FORM_FIELD_TYPES = [
  { id: 'text', label: 'Short text' },
  { id: 'textarea', label: 'Long text' },
  { id: 'email', label: 'Email' },
  { id: 'tel', label: 'Phone' },
  { id: 'url', label: 'URL' },
  { id: 'number', label: 'Number' },
  { id: 'select', label: 'Dropdown' },
  { id: 'radio', label: 'Radio' },
  { id: 'checkbox', label: 'Checkbox' },
  { id: 'date', label: 'Date' },
  { id: 'rating', label: 'Rating' },
];

export function fieldTypeLabel(type) {
  return FORM_FIELD_TYPES.find((item) => item.id === type)?.label || 'Short text';
}

export function optionList(field) {
  if (Array.isArray(field?.options)) {
    return field.options.map((option) => String(option).trim()).filter(Boolean);
  }
  if (typeof field?.options === 'string') {
    return field.options.split(',').map((option) => option.trim()).filter(Boolean);
  }
  return [];
}

export function slugKey(label, index) {
  const key = String(label || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
  return key || `field_${index + 1}`;
}

export function blankField(index) {
  return {
    key: `question_${index + 1}`,
    label: 'New question',
    type: 'text',
    required: false,
    help: '',
    options: [],
  };
}
